module.exports = __webpack_public_path__ + "img/banner.a565906d.jpg";